import Seo from "@/components/Seo";
import Hero from "@/sections/Hero";
import Marquee from "@/components/Marquee";
import TrustSignals from "@/sections/TrustSignals";
import ServiceCategories from "@/sections/ServiceCategories";
import BeforeAfterSection from "@/sections/BeforeAfterSection";
import AdvisorSection from "@/sections/AdvisorSection";
import CaseStudiesSection from "@/sections/CaseStudiesSection";
import BlogSection from "@/sections/BlogSection";
import ReviewsSection from "@/sections/ReviewsSection";
import FaqSection from "@/sections/FaqSection";
import LocationSection from "@/sections/LocationSection";
import FinalCta from "@/sections/FinalCta";
import { useSettings } from "@/context/SettingsContext";
import { useFaqs } from "@/lib/queries";
import { localBusiness, faqSchema } from "@/lib/schema";

export default function Home() {
  const settings = useSettings();
  const { data: faqs = [] } = useFaqs();

  const schema = [localBusiness(settings)];
  const fq = faqSchema(faqs);
  if (fq) schema.push(fq);

  return (
    <>
      <Seo
        title="Meguiar's İzmit | Kocaeli Premium Araç Koruma ve Bakım Merkezi"
        description="Kocaeli'nin ilk ve lider Meguiar's araç bakım merkezi. Seramik kaplama, PPF kaplama, boya koruma, detaylı iç temizlik ve cam filmi hizmetlerinde profesyonel uygulama."
        canonicalPath="/"
        image="/img/home-og.webp"
        jsonLd={schema}
      />
      <Hero />
      <Marquee />
      <TrustSignals />
      <ServiceCategories />
      <BeforeAfterSection />
      <AdvisorSection />
      <CaseStudiesSection />
      <BlogSection />
      <ReviewsSection />
      <FaqSection />
      <LocationSection />
      <FinalCta />
    </>
  );
}
